import { bunja } from 'bunja';

import { r230522SocketBunja } from './socket';

// context: https://prextech.slack.com/archives/CSJUWFLAG/p1731649392695179
export const detailBunja = bunja(() => {
  const { r230522Socket } = bunja.use(r230522SocketBunja);
  type Detail = string | null;
  let currentPswapDetail: Detail = null;
  let currentSpotDetail: Detail = null;

  function getCurrentDetail() {
    return currentPswapDetail || currentSpotDetail;
  }

  function updateSubs() {
    r230522Socket.send({ s: { symbol: getCurrentDetail() } });
  }

  // FIXME: 땜빵을 위한 코드.. detail을 여러 심볼에 대해 구독할 수 있도록 바꾼뒤 없애야 함
  // 인자로 들어온 symbol에 대해서 구독 요청한 뒤 바로 기존 symbol의 구독으로 전환해주는 함수
  // 모달 등을 띄울 때 해당 모달에서 필요로 하는 정보를 땡겨오기 위함
  function triggerSymbolUpdate(symbol: string) {
    const current = getCurrentDetail();
    if (symbol === current) return;
    r230522Socket.send({ s: { symbol } });
    if (current) r230522Socket.send({ s: { symbol: current } });
  }

  function safeUpdate(newDetail: Detail, setFn: (newDetail: Detail) => void) {
    const currentDetail = getCurrentDetail();
    setFn(newDetail);
    if (currentDetail !== newDetail) updateSubs();
  }

  function setCurrentPswapDetail(detail: Detail = null) {
    safeUpdate(detail, () => {
      currentPswapDetail = detail;
      currentSpotDetail = null;
    });
  }

  function setCurrentSpotDetail(detail: Detail = null) {
    safeUpdate(detail, () => {
      currentSpotDetail = detail;
      currentPswapDetail = null;
    });
  }

  bunja.effect(() => {
    updateSubs();
    r230522Socket.on('connected', updateSubs);

    return () => {
      currentPswapDetail = null;
      currentSpotDetail = null;
      updateSubs();
      r230522Socket.off('connected', updateSubs);
    };
  });

  return {
    triggerSymbolUpdate,
    setCurrentPswapDetail,
    setCurrentSpotDetail,
  };
});
detailBunja.debugLabel = 'detailBunja';
